import { FetcherError } from '@commerce/utils/errors'
import parentLogger from '@utils/logger'

const logger = parentLogger.child({ name: 'common.ts' })

const platformApiUrl = process.env.PLATFORM_API_URL
const platformApiToken = process.env.PLATFORM_API_TOKEN

export const BIGCOMMERCE_CHANNEL_COUNTRY =
  process.env.BIGCOMMERCE_CHANNEL_COUNTRY

const apolloClientName =
  process.env.CI === 'true'
    ? `everest-bitbucket`
    : `everest-${
        process.env.SENTRY_ENVIRONMENT || 'local'
      }-${BIGCOMMERCE_CHANNEL_COUNTRY}`

export const fetchPlatformGraphqlApi = async (
  query: string,
  { variables } = { variables: {} },
  fetchOptions?: any
) => {
  const res = await fetch(platformApiUrl, {
    ...fetchOptions,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${platformApiToken}`,
      ...fetchOptions?.headers,
      'Content-Type': 'application/json',
      'apollographql-client-name': apolloClientName,
      'apollographql-client-version': process.env.SENTRY_VERSION || '1.0',
    },
    body: JSON.stringify({
      query,
      variables,
    }),
    next: { revalidate: 900 },
  })

  if (res.headers.get('content-type').includes('json')) {
    const json = await res.json()
    if (json.errors) {
      throw new FetcherError({
        errors: json.errors ?? [{ message: 'Failed to fetch Platform API' }],
        status: res.status,
      })
    }
    return { data: json.data, res }
  } else {
    const body = await res.text()
    logger.error(
      { query, platformApiUrl, body },
      'Non-JSON response received from Platform API'
    )
    throw new FetcherError({
      errors: [
        { message: 'Non-JSON response body received from Platform API' },
      ],
      status: res.status,
    })
  }
}
